import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import OrderSummaryItem from './OrderSummaryItem';

const FLOWS = {
    UPGRADE: 'upgrade',
    PURCHASE: 'purchase',
    EXTEND: 'extend',
};

const getOrderSummaryDetails = (flow, selectedPackage, price, extras, dueDate, remainingDays, totalPrice) => (
    <div>
        <OrderSummaryItem
            title={ selectedPackage.name + ' Plan'}
            amount={ parseFloat(price).toLocaleString() }
        >
            { flow === FLOWS.UPGRADE
                ? <ul className="block font-sans-serif font-size-14px font-gray-40 font-w-4 order-summary__list-style pad-l-16px pad-t-8px">
                    <li><span className="font-w-7">Contract End Date: </span>{ new Date(dueDate).toLocaleDateString('en-US') }</li>
                    <li><span className="font-w-7">Upgrade: </span>{ remainingDays } remaining days</li>
                </ul>
                : <span className="block font-sans-serif font-size-14px font-gray-40 font-w-4">1,000 Contacts Included</span>
            }
        </OrderSummaryItem>

        { extras.price
            ? <OrderSummaryItem
                title="Additional Contacts"
                amount={ extras.price.toLocaleString() }
            >
                <span className="block font-sans-serif font-size-14px font-gray-40 font-w-4">{ extras.label }</span>
            </OrderSummaryItem>
            : null
        }

        <hr className="order-separator border-color-gray-40 border-solid margin-b-32px margin-t-32px"/>

        <div className="text-align-left">
            <OrderSummaryItem
                title="Total Price"
                amount={ totalPrice }
            >
                { flow !== FLOWS.UPGRADE
                    ? <span className="block font-sans-serif font-size-14px font-gray-40 font-w-4">{ (extras.contacts + 1000).toLocaleString() } Total Contacts</span>
                    : null
                }
            </OrderSummaryItem>
        </div>
    </div>
);

function OrderSummary({
    selectedPackage = {},
    price = '',
    extras = {},
    dueDate = '',
    flow = '',
}) {
    const [remainingDays, setRemainingDays] = useState(dayjs(dueDate).diff(dayjs(), 'day'));
    const [totalPrice, setTotalPrice] = useState((parseFloat(price) + extras.price).toLocaleString());
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        setRemainingDays(dayjs(dueDate).diff(dayjs(), 'day'));
        setTotalPrice((parseFloat(price) + extras.price).toLocaleString());
    }, [dueDate, price, extras.price]);

    return (
        <div>
            <div className="accordian md-none">
                <h3 className="accordian-heading-group margin-t-0px margin-b-0px font-size-16px font-serif font-blue-16 bg-blue-90">
                    <button
                        id="accordianHeadingId"
                        className="accordian-heading-button pad-t-20px pad-b-20px pad-l-16px pad-r-16px text-align-right"
                        aria-expanded={expanded}
                        aria-controls="orderSummaryPanel"
                        onClick={() => { setExpanded((prev) => !prev); }}
                    >
                        <span className="relative float-left">Order Summary</span>
                        { !expanded
                            ? <span className="margin-r-16px font-sans-serif font-size-14px font-blue-16">${ totalPrice }</span>
                            : null
                        }
                        <i className={'relative float-right fa fa-chevron-up ease-125ms' + (expanded ? ' transform-rotate-180' : '')}></i>
                    </button>
                </h3>
                <div
                    id="orderSummaryPanel"
                    className={ 'accordian-panel bg-white' + (expanded ? ' show' : ' hide')}
                    aria-label="accordianHeadingId"
                >
                    <div className="pad-t-24px pad-r-16px pad-l-16px pad-b-24px">
                        { getOrderSummaryDetails(flow, selectedPackage, price, extras, dueDate, remainingDays, totalPrice) }
                    </div>
                </div>
            </div>
            <div className="order-summary-container none md-block border-solid border-radius-10px border-solid border-1px border-color-gray-45 flex flex-dir-col overflow-hidden">
                <div className="order-heading-container flex flex-dir-col">
                    <h2 className="text-align-center font-serif font-size-24px font-blue-16 margin-t-auto margin-b-auto">ORDER SUMMARY</h2>
                </div>

                <div className="pad-t-16px pad-b-16px pad-r-16px pad-l-16px lg-pad-t-32px lg-pad-b-32px lg-pad-r-32px lg-pad-l-32px">
                    { getOrderSummaryDetails(flow, selectedPackage, price, extras, dueDate, remainingDays, totalPrice) }
                </div>
            </div>
        </div>
    );
}

OrderSummary.propTypes = {
    selectedPackage: PropTypes.object.isRequired,
    price: PropTypes.string.isRequired,
    extras: PropTypes.object,
    dueDate: PropTypes.string,
    flow: PropTypes.oneOf(Object.values(FLOWS)),
};

export { OrderSummary, FLOWS };
